import { DIValidators, EFeatureFlags, F360Product } from "@/core/@types/types";
import { diContainer } from "@/core/di";
import { F360PageTitles } from "@/core/router/F360PageTitles";
import useF360Router from "@/core/router/useF360Router";
import { IF360FeatureFlagValidator } from "@/core/validators/F360FeatureFlagValidator";
import type { RouteRecordRaw } from "vue-router";

const { handleRouterPrefixName, handlePrefixName } = useF360Router();

const hasIntegracoesFeatureFlag = () =>
  diContainer
    .get<IF360FeatureFlagValidator>(DIValidators.FEATURE_FLAGS)
    .handleValidationByName(EFeatureFlags.Integracoes);

const redirectToLegacyWhenFeatureIsDisabled = () => {
  if (hasIntegracoesFeatureFlag()) return true;

  window.location.replace("/Webservice");

  return false;
};

export enum EIntegracoes {
  Index = "index",
  Painel = "painel"
}

export const integracoesRouter: Array<RouteRecordRaw> = handleRouterPrefixName(
  [
    {
      path: "/integracoes/",
      component: () =>
        import("@/features/financas/views/Integracoes/IntegracoesBase.vue"),
      name: EIntegracoes.Index,
      redirect: {
        name: handlePrefixName(F360Product.Integracoes, EIntegracoes.Painel)
      },
      beforeEnter: redirectToLegacyWhenFeatureIsDisabled,
      meta: {
        module: F360Product.Integracoes,
        hasSubRoutes: true,
        title: F360PageTitles.Integracoes
      },
      children: [
        {
          path: "painel-de-integracoes",
          component: () =>
            import("@/features/financas/views/Integracoes/views/painel/IntegracoesPainel.vue"),
          name: EIntegracoes.Painel,
          meta: {
            title: F360PageTitles.Integracoes
          }
        }
      ]
    }
  ],
  F360Product.Integracoes
);
